module.exports = __webpack_public_path__ + "build/img/serm.a4c42a7a.jpg";